<div class="page-content-container">
  <!-- Dynamic search filters component -->
  <app-datasafra-search-reports
    [resultCount]="length >= 500 ? 500 : length"
    (downloadClick)="downloadPage()"
    [filterFields]="filterConfig"
    (filtersChange)="handleFilters($event)"
  ></app-datasafra-search-reports>

  <!-- Dynamic reports table -->
  <app-reports-table
    [dataSource]="dataSource"
    [isLoading]="(gridLoading$ | async) ?? false"
    [length]="length"
    [config]="tableConfig"
    [actions]="tableActions"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
  ></app-reports-table>
</div>
